import { render, staticRenderFns } from "./TeamEdit.vue?vue&type=template&id=5b8c87dc"
import script from "./TeamEdit.js?vue&type=script&lang=js&external"
export * from "./TeamEdit.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports